import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';
import '@coog/react-components/dist/react-components.css';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { createBrowserHistory } from 'history';

import 'material-design-icons/iconfont/material-icons.css';
import 'typeface-roboto/index.css';

import * as serviceWorker from './serviceWorker';
import Routes from './Routes';
import configureStore from './Store/configureStore';
import cookiesCleanUp from 'cookiesCleanUp';

const history = createBrowserHistory();
const store = configureStore(history);
const rootClass = 'coog';

cookiesCleanUp();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div className={rootClass}>
        <Routes />
      </div>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();